import { render, staticRenderFns } from "./SolidGateCard.vue?vue&type=template&id=86821590&scoped=true"
import script from "./SolidGateCard.vue?vue&type=script&lang=js"
export * from "./SolidGateCard.vue?vue&type=script&lang=js"
import style0 from "./SolidGateCard.vue?vue&type=style&index=0&id=86821590&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86821590",
  null
  
)

export default component.exports